import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44b296cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card reports--room" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 0,
  class: "card-body"
}
const _hoisted_4 = { key: 0 }

import { computed, ref, onMounted, provide } from 'vue';
import { useStore } from 'vuex';
import {
  Compliancesection,
  Compliancequestion,
  Complianceitem,
} from "@/models";
import ComplianceItem from "@/components/visitchecks/ComplianceItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComplianceSection',
  props: {
    compliancesection: {},
    index: {},
    toggle: { type: Boolean },
    opened: { type: Boolean }
  },
  emits: ['showBody'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const store = useStore();

const _compliancesection = computed(() => props.compliancesection);
const _index = computed(() => props.index);
const _toggle = computed(() => props.toggle);
const _opened = computed(() => props.opened);

provide("sectionIndex", _index.value);

const showBody = ref(true);

const setReportDeepWithoutCounting = (payload: { path: string; data: any }) => {
  store.dispatch('reports/setReportDeepWithoutCounting', payload);
};

const compliancelist = computed((): Compliancequestion[] => store.getters['customerdictionary/compliancelist']);

const emit = __emit

// Methods
const toggleShowBody = () => {
  if (_toggle.value) {
    showBody.value = !_opened.value;
    emit('showBody', _index.value, showBody.value);
  }
};

onMounted(async () => {
  if (_compliancesection.value && compliancelist.value) {
    if (!_compliancesection.value.complianceitems) {
      _compliancesection.value.complianceitems = [];
      await setReportDeepWithoutCounting({
        path: `compliancesections[${_index.value}].complianceitems`,
        data: _compliancesection.value.complianceitems,
      });
    }

    let sectionitem = false;
    let newcompliancelist: Complianceitem[] = [];
    compliancelist.value.forEach((question) => {
      let headingitem = false;
      if (question.questionType === "heading") {
        headingitem = true;
        sectionitem = question.prompt === _compliancesection.value.heading;
      }
      if (!headingitem && sectionitem) {
        let existingitem = _compliancesection.value.complianceitems.find(
          (i) => i.slug === question.slug
        );
        let item: Complianceitem = new Complianceitem();
        if (!existingitem) {
          item.slug = question.slug;
          item.prompt = question.prompt;
          item.photos = [];
        } else {
          item.slug = existingitem.slug;
          item.prompt = existingitem.prompt;
          item.notes = existingitem.notes;
          item.value = existingitem.value;
          item.photos = existingitem.photos;
        }
        newcompliancelist.push(item);
        item.subheadingitem = question.questionType === "subheading";
      }
    });
    _compliancesection.value.complianceitems = newcompliancelist;
    setReportDeepWithoutCounting({
      path: `compliancesections[${_index.value}].complianceitems`,
      data: _compliancesection.value.complianceitems,
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-header", { 'toggle-body': _toggle.value }])
    }, [
      _createElementVNode("h2", {
        class: "mb-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleShowBody()))
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_compliancesection.value.heading), 1)
      ])
    ], 2),
    (_opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_compliancesection.value.complianceitems, (complianceitem, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: complianceitem._uuid
            }, [
              (complianceitem.subheadingitem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("h5", null, _toDisplayString(complianceitem.prompt), 1)
                  ]))
                : (_openBlock(), _createBlock(ComplianceItem, {
                    key: 1,
                    complianceitem: complianceitem,
                    index: $index,
                    toggle: false
                  }, null, 8, ["complianceitem", "index"]))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})